export const ROUTE = {
  OAUTH: '/auth/oauth',
  FREE: '/auth/free',
  DEV: '/auth/dev'
}